// Re-export departements.json as a module with proper typing
import data from './departements.json' with { type: 'json' };

const departementsData: GeoJSON.FeatureCollection = data as GeoJSON.FeatureCollection;
export default departementsData;
